<template>
  <div id="content-wrapper">
    <form @submit.prevent>
      <div>
        <div class="row m-0 mb-3 justify-content-space-between">
          <div
            class="
              p-0
              col-xl-5 col-lg-6
              d-flex
              align-items-center
              justify-content-space-between
            "
          >
            <b-form-input
              v-if="false"
              @keyup.enter="timDanhSachVaiTro"
              id="filterBy"
              placeholder="Nhập từ khóa tìm kiếm"
              required
              type="text"
              v-model="requestInformation.filterBy"
            />
            <div class="font-weight-bold">Tên ứng dụng</div>
            <v-select
              class="flex-1-0 ml-2"
              :options="listAppPermissions"
              id="id"
              label="name"
              :reduce="(app) => app.id"
              v-model="requestInformation.appId"
              :readonly="true"
              placeholder="Chọn ứng dụng"
              :disabled="isIframe"
            >
              <span slot="no-options"> Không tìm thấy dữ liệu </span></v-select
            >
          </div>
          <div class="ml-2">
            <base-button
              button="Tìm kiếm"
              @click="timDanhSachVaiTro()"
              v-if="false"
            />

            <base-button
              button="Thêm mới"
              v-if="hasPermissionUser(PERMISSION_NAME.VAI_TRO.THEM)"
              @click="themMoi()"
              class="btn search-information-btn d-block float-right"
            >
              THÊM MỚI
            </base-button>
          </div>
        </div>
      </div>
    </form>
    <div class="box-form-result">
      <p class="color-gray-1">Tìm thấy {{ totalRows }} kết quả</p>
      <DataTable :loading="isLoadingTable" :value="items">
        <Column
          field="id"
          dataKey="id"
          headerStyle="width: 40px"
          headerClass="p-2"
          header="STT"
          bodyStyle="text-align: center"
        >
          <template #filter> </template>
          <template #body="slotProps">
            <span>{{
              (requestInformation.pageIndex - 1) * requestInformation.pageSize +
                slotProps.index +
                1
            }}</span>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="name"
          header="Tên vai trò"
          headerStyle="minWidth: 200px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestForm.RoleName"
              @change="timDanhSachVaiTro"
            />
          </template>
          <template #body="slotProps">
            <router-link
              class="color-unset"
              :to="
                `${ROUTE_NAME.QUAN_TRI_HE_THONG.VAI_TRO}/${slotProps.data.id}/xem`
              "
            >
              <span>{{ slotProps.data.name }}</span>
            </router-link>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="appName"
          header="Ứng dụng"
          headerStyle="minWidth: 200px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestForm.ApplicationName"
              @change="timDanhSachVaiTro"
            />
          </template>
          <template #body="slotProps">
            <div v-html="slotProps.data.appName"></div>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="thaoTac"
          header="Thao tác"
          v-if="
            hasPermissionUser(PERMISSION_NAME.VAI_TRO.XOA) ||
              hasPermissionUser(PERMISSION_NAME.VAI_TRO.SUA)
          "
          headerStyle="width: 100px"
        >
          <template #body="slotProps">
            <div class="text-center">
              <router-link
                v-if="hasPermissionUser(PERMISSION_NAME.VAI_TRO.SUA)"
                class="color-unset"
                :to="
                  `${ROUTE_NAME.QUAN_TRI_HE_THONG.VAI_TRO}/${slotProps.data.id}`
                "
              >
                <font-awesome-icon
                  icon="edit"
                  v-b-popover.hover.top="'Sửa vai trò'"
                  class="cursor-pointer color-red"
                />
              </router-link>
              <font-awesome-icon
                v-if="hasPermissionUser(PERMISSION_NAME.VAI_TRO.XOA)"
                icon="trash-alt"
                v-b-popover.hover.top="'Xóa vai trò'"
                class="cursor-pointer color-red ml-2"
                @click="moFormXoaVaiTro(slotProps.data)"
              />
            </div>
          </template>
        </Column>
        <template #empty
          ><div class="text-center">Không có dữ liệu</div></template
        >
        <template #loading
          ><div class="text-center">Đang tải dữ liệu ...</div>
        </template>
      </DataTable>
    </div>
    <BasePagination
      class="mt-3"
      :current-page="requestInformation.pageIndex"
      :total-pages="totalPages"
      :total-rows="totalRows"
      @changeNum="onChangeNum($event)"
      @changePages="onChangePages($event)"
    />
    <b-modal
      centered
      ref="tao-vai-tro-modal"
      size="xl"
      title="Tạo vai trò"
      :no-close-on-backdrop="true"
    >
      <FormVaiTro ref="tao-vai-tro" :danh-sach-app="danhSachApp" />
      <template v-slot:modal-footer>
        <div class="w-100 center">
          <base-button
            :button="BO_QUA_BUTTON_LABEL"
            @click="hideModal()"
            class="btn btn-line"
          >
            {{ BO_QUA_BUTTON_LABEL }}
          </base-button>
          <base-button
            button="Tạo"
            @click="taoVaiTro()"
            class="btn btn-main ml-2"
          >
            Tạo
          </base-button>
        </div>
      </template>
    </b-modal>
    <ModalConfirm
      :title="vaiTroDaChon.displayName"
      @confirmed="xoaVaiTroThanhCong"
    />
  </div>
</template>

<script>
import BasePagination from "@/components/common/BasePagination";
import FormVaiTro from "@/components/pages/quan-tri-he-thong/vai-tro/FormVaiTro";
import ModalConfirm from "@/components/modal/ModalConfirm";
import {
  BO_QUA_BUTTON_LABEL,
  ROUTE_NAME,
  PERMISSION_NAME,
} from "@/constants/constants";
import { TAO_VAI_TRO_THANH_CONG } from "@/constants/message";
import { mapGetters } from "vuex";
import _isEmpty from "lodash/isEmpty";
import _isNil from "lodash/isNil";
import {
  LOCAL_STORAGE_KEY,
  setValueToStorageByKey,
} from "@/utils/localStorage";
import { hasPermissionUser } from "@/utils/permissionUtils";

export default {
  name: "DanhSachVaiTro",
  components: {
    BasePagination,
    FormVaiTro,
    ModalConfirm,
  },
  data() {
    return {
      PERMISSION_NAME,
      ROUTE_NAME: ROUTE_NAME,
      BO_QUA_BUTTON_LABEL: BO_QUA_BUTTON_LABEL,
      items: [],
      requestInformation: {
        appId: null,
        sortType: "",
        pageSize: 10,
        pageIndex: 1,
        sortBy: "ThuTu",
      },
      requestInternalForm: {},
      totalPages: 0,
      totalRows: 0,
      isLoadingTable: true,
      vaiTroDaChon: {},
      requestForm: {},
    };
  },
  computed: {
    ...mapGetters({
      danhSachApp: "app/tatCaApp",
      listApp: "app/listApp",
      danhSachVaiTro: "role/danhSachVaiTroTheoApp",
      appId: "common/appId",
      isIframe: "common/isIframe",
    }),
    listAppPermissions() {
      if(this.listApp && this.listApp.length > 0) {
        let convertDataListApp = this.listApp.map((item) => {
          return {
            ...item,
            code: item.appCode
          }
        })
        let arrayData = []
        this.danhSachApp.forEach((item) => convertDataListApp.forEach((item2) => {
          if(item.code === item2.code) {
            arrayData.push(item)
          }
        }))
        return arrayData
      }
      return []
    },
    hasPageData() {
      return !_isEmpty(this.danhSachVaiTro.items);
    },
  },
  watch: {
    danhSachVaiTro: {
      handler() {
        this.totalPages = this.danhSachVaiTro.totalPage;
        this.totalRows = _isNil(this.danhSachVaiTro.totalCount)
          ? 0
          : this.danhSachVaiTro.totalCount;
        this.items = this.danhSachVaiTro.items;
      },
      immediate: true,
    },
    "requestInformation.pageIndex": {
      handler() {
        this.layDanhSachVaiTro();
      },
    },
    "requestInformation.appId": {
      handler() {
        this.timDanhSachVaiTro();
        setValueToStorageByKey(
          LOCAL_STORAGE_KEY.APP_ID,
          this.requestInformation.appId
        );
        this.$store.dispatch("common/setAppId", this.requestInformation.appId);
      },
      deep: true,
    },
  },
  created() {
    //let appId = getValueFromStorageByKey(LOCAL_STORAGE_KEY.APP_ID);
    // this.requestInformation.appId = this.appId;
    this.layDanhSachApp();
    this.layDanhSachVaiTro();
    this.$store.dispatch("app/getListApp");
  },
  methods: {
    hasPermissionUser,
    themMoi() {
      this.$router.push({
        path: `${ROUTE_NAME.QUAN_TRI_HE_THONG.VAI_TRO}/tao-moi`,
        params: {
          laTaoMoi: true,
        },
      });
    },
    layDanhSachApp() {
      this.$store.dispatch("app/layTatCaApp");
    },
    moFormTaoVaiTro() {
      this.$refs["tao-vai-tro-modal"].show();
    },
    hideModal() {
      this.$refs["tao-vai-tro-modal"].hide();
    },
    async taoVaiTro() {
      const isValid = await this.$refs["tao-vai-tro"].$refs.observer.validate();
      const $vm = this;
      if (isValid) {
        this.$store
          .dispatch(
            "role/taoVaiTro",
            this.$refs["tao-vai-tro"].getInternalForm()
          )
          .then((response) => {
            if (response.data.succeeded) {
              $vm.$toasted.clear();
              $vm.$toasted.global.showSuccessMessage({
                message: TAO_VAI_TRO_THANH_CONG,
              });
              $vm.$refs["tao-vai-tro-modal"].hide();
              $vm.layDanhSachVaiTro();
            }
          });
      }
    },
    onChangeNum(pageSize) {
      this.requestInformation.pageIndex = 1;
      this.requestInformation.pageSize = pageSize;
      this.layDanhSachVaiTro();
    },
    onChangePages(page) {
      this.requestInformation.pageIndex = page;
    },
    timDanhSachVaiTro(requestForm) {
      this.requestInformation.pageIndex = 1;
      this.requestInternalForm = requestForm;
      this.layDanhSachVaiTro();
    },
    layDanhSachVaiTro() {
      const payload = {
        ...this.requestInternalForm,
        ...this.requestInformation,
        ...this.requestForm,
      };
      this.isLoadingTable = true;
      this.$store
        .dispatch("role/layDanhSachVaiTroTheoApp", payload)
        .then(() => {
          this.isLoadingTable = false;
        });
    },

    moFormXoaVaiTro(item) {
      this.vaiTroDaChon = item;
      this.$bvModal.show("modal-confirm");
    },
    xoaVaiTroThanhCong(confirm) {
      if (confirm) {
        this.$bvModal.hide("modal-confirm");
        this.$store
          .dispatch("role/xoaVaiTro", { id: this.vaiTroDaChon.id })
          .then(() => this.layDanhSachVaiTro());
      }
    },
  },
};
</script>
